var impressum = "Vastuuvapaus";
var privacy = "Tietosuoja ja lakiasiat";
var recallInfo = "Takaisinkutsun tiedot";
var signOut = "Kirjaudu ulos";
var fi_fi = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { fi_fi as default, impressum, privacy, recallInfo, signOut };
